export const FLAG_ITINERARY_QUALITY_ACTIVITY =
  'FLAG_ITINERARY_QUALITY_ACTIVITY';
export const GET_ITINERARY_QUALITY = 'GET_ITINERARY_QUALITY';
export const CLEAR_ITINERARY_QUALITY = 'CLEAR_ITINERARY_QUALITY';
